import { FeatureFlag } from 'core/service/feature-flag/feature-flag.model';
import { createContext } from 'react';

export type FeatureFlagsContextType = {
    featureFlags?: FeatureFlag[];
    isLoading?: boolean;
};

export const FeatureFlagsContext = createContext<FeatureFlagsContextType>({});
